import { AtestadoPlanoInput, TipoAtestadoEnum } from 'graphql/types.generated'
import { dateAsYyyyMmDd, formatHoursMinutes } from 'util/date/formatDate'

import { AtestadoPlanoModel } from './AtestadosView'
import AtestadoModel from './components/model-atestado'
import { AtestadoQueryModel, AtestadoRetificacaoQueryModel } from './model-atestado'

export const convertAtestadoPlanoFormToInput = (atestados: AtestadoPlanoModel): AtestadoPlanoInput => {
  const somenteNovos = atestados.atestadosRecentes?.filter((item) => !item.editingId)

  const emBranco = somenteNovos?.filter((it) => it.tipo === TipoAtestadoEnum.EM_BRANCO)
  const padrao = somenteNovos?.filter((it) => it.tipo === TipoAtestadoEnum.PADRAO)
  const licencaMaternidade = somenteNovos?.filter((it) => it.tipo === TipoAtestadoEnum.LICENCA_MATERNIDADE)
  const solicitacaoFraldasGeriatricas = somenteNovos?.filter(
    (it) => it.tipo === TipoAtestadoEnum.SOLICITACAO_FRALDAS_GERIATRICAS
  )

  return {
    emBranco: emBranco?.map((it) => ({
      id: it.editingId,
      descricao: it.descricao,
      assinadoDigitalmente: it.assinadoDigitalmente ?? false,
    })),
    licencaMaternidade: licencaMaternidade?.map((it) => ({
      id: it.editingId,
      descricao: it.descricao,
      cpfCns: it.cpfCns,
      naoPossui: it.naoPossui,
      assinadoDigitalmente: it.assinadoDigitalmente ?? false,
    })),
    padrao: padrao?.map((it) => ({
      id: it.editingId,
      descricao: it.descricao,
      cpfCns: it.cpfCns,
      naoPossui: it.naoPossui,
      date: it.data,
      hora: it.hora,
      cid10Id: it.cid10?.id,
      dias: it.dias,
      assinadoDigitalmente: it.assinadoDigitalmente ?? false,
    })),
    solicitacaoFraldasGeriatricas: solicitacaoFraldasGeriatricas?.map((it) => ({
      id: it.editingId,
      descricao: it.descricao,
      cpfCns: it.cpfCns,
      naoPossui: it.naoPossui,
      cid10Id: it.cid10?.id,
      tamanhoFralda: it.tamanhoFralda,
      unidadesPorDia: it.unidadesPorDia,
      assinadoDigitalmente: it.assinadoDigitalmente ?? false,
    })),
  }
}

export const convertAtestadoQueryToForm = (item: AtestadoQueryModel): AtestadoModel => {
  const { id, descricao, tipo, assinadoDigitalmente } = item

  return {
    editingId: id,
    descricao,
    tipo,
    assinadoDigitalmente,
  }
}

export function convertAtestadosQueryRetificacaoToForm(
  atestados: ReadonlyArray<AtestadoRetificacaoQueryModel>,
  cidadaoCpfCns: string | undefined
): AtestadoPlanoModel {
  return {
    atestadoModelo: undefined,
    atestadosRecentes: atestados.map((atestado) => convertAtestadoQueryRetificacaoToForm(atestado, cidadaoCpfCns)),
  }
}

function convertAtestadoQueryRetificacaoToForm(
  atestado: AtestadoRetificacaoQueryModel,
  cidadaoCpfCns: string | undefined
): AtestadoModel {
  return {
    descricao: atestado.descricao,
    assinadoDigitalmente: atestado.assinadoDigitalmente,
    tipo: atestado.tipo,
    cid10: atestado.cid10,
    data: dateAsYyyyMmDd(atestado.dataHorarioAfastamento),
    hora: atestado.dataHorarioAfastamento ? formatHoursMinutes(atestado.dataHorarioAfastamento) : undefined,
    cpfCns: cidadaoCpfCns,
    naoPossui: !cidadaoCpfCns,
    dias: atestado.dias,
  }
}
